<template>
  <v-container>
    <trade-attachments :id="$route.params.id"/>
  </v-container>
</template>

<script>
export default {
  components: {
    TradeAttachments: () => import('@/components/TradeAttachments.vue'),
  },
  data: () => ({}),
};
</script>
